export { default } from "./BookmarkList";
